module.exports = __webpack_public_path__ + "static/media/background.5fb75c03.png";